<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">
                <!-- <div class="card-header bg-transparent pb-5">
                    <div class="text-muted text-center mt-2 mb-3">
                        <small>Sign up with</small>
                    </div>
                    <div class="btn-wrapper text-center">
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                            <span class="btn-inner--text">Github</span>
                        </a>
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                            <span class="btn-inner--text">Google</span>
                        </a>
                    </div>
                </div> -->
                <div class="card-body px-lg-5 py-lg-5" :dir="language">
                    <div class="text-center text-muted mb-4">
                        <h3>{{texts.registration}}</h3>
                    </div>
                    <form role="form">

                        <base-input class="input-group-alternative mb-3"
                                    :placeholder="texts.title"
                                    addon-left-icon="ni ni-hat-3"
                                    v-model="title">
                        </base-input>


                        <div class="row">
                          <div class="col-md-2">
                            <vue-country-code style="height:43px;margin-top:1px;"
                                 @onSelect="onSelect"
                                 :preferredCountries="['sa', 'ae', 'bh', 'jo']">
                            </vue-country-code>
                          </div>
                          <div class="col-md-10">
                            <base-input class="input-group-alternative mb-3"
                                        :placeholder="texts.phonenumber"
                                        addon-left-icon="ni ni-hat-3"
                                        v-model="phonenumber">
                            </base-input>
                          </div>
                        </div>




                        <base-input class="input-group-alternative"
                                    :placeholder="texts.newpass"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    v-model="password">
                        </base-input>

                        <!-- <div class="text-muted font-italic">
                            <small>password strength: <span class="text-success font-weight-700">strong</span></small>
                        </div>

                        <div class="row my-4">
                            <div class="col-12">
                                <base-checkbox class="custom-control-alternative">
                                    <span class="text-muted">I agree with the <a href="#!">Privacy Policy</a></span>
                                </base-checkbox>
                            </div>
                        </div> -->
                        <div class="text-center md-8">
                            <base-button type="primary mb-3" style="width:350px;" class="my-4" v-on:click="register()">Complete Registration</base-button>
                        </div>
                    </form>
                </div>
            </div>
            <!-- <div class="row mt-3">
                <div class="col-6">
                    <a href="#" class="text-light">
                        <small>Forgot password?</small>
                    </a>
                </div>
                <div class="col-6 text-right">
                    <router-link to="/login" class="text-light">
                        <small>Login into your account</small>
                    </router-link>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
  import { mapState } from "vuex";
  import { COMMITTEE_REGISTER } from "@/store/actions.type";
  import store from "@/store";
  import UserService from "@/common/user.service";
  import VueCountryCode from "vue-country-code";


  export default {
    name: 'register',
    components: {
      VueCountryCode
    },
    data() {
      return {
        texts : {
          registration : UserService.getLanguage() === "rtl" ? "التسجيل" : "Registration",
          register : UserService.getLanguage() === "rtl" ? "تسجيل" : "Register",
          phonenumber : UserService.getLanguage() === "rtl" ? "رقم الهاتف" : "Phone Number",
          title : UserService.getLanguage() === "rtl" ? "المسمى الوظيفي" : "Title",
          newpass : UserService.getLanguage() === "rtl" ? "كلمة السر الجديدة" : "New Password"
        },
        language : UserService.getLanguage() || "ltr",
        title : "",
        phonenumber : "",
        password: "",
        country_code : ""

      }
    },
    mounted() {
      if (UserService.getUserId() === "" || UserService.getUserId() == undefined) {
        this.$router.push({ name: "login" })
      }

    },
    methods : {
      onSelect({name, iso2, dialCode}) {
       console.log(name, iso2, dialCode);
       this.country_code = dialCode;
     },
      register() {
        if (this.title !== "" && this.phonenumber !== "" && this.password !== "") {
          if (this.phonenumber.length === 10 && this.phonenumber.startsWith("0")) {
            this.phonenumber.substring(1, this.phonenumber.length);
          }
          let formData = {'title' : this.title, 'phone_number': "+" + this.country_code +this.phonenumber, 'password' : this.password, 'id' : UserService.getUserId()};
          console.log(formData);
          Promise.all([
            store.dispatch(COMMITTEE_REGISTER, formData),

          ]).then((data) => {
            this.isLoading = false;
            if (data[0]['data']) {
                      if (data[0]['data']['reset']) {
                        if (Number(data[0]['data']['reset']) === 1) {
                          this.$router.push({ name: "resetpass" });
                        }
                      }
                    }
                    else {
                      if (data[0]['assignments'].length > 1) {
                        this.$router.push({ name: "assignments" });
                      }
                      //
                      else if (data[0]['assignments'].length === 0) {
                        this.$router.push({ name: "assignments" });
                      }
                      //
                      else {
                        console.log("PUSHING ROUTER TO OVERVIEW");
                        this.$router.push({ name: "overview" });
                      }
                    }
            // this.$router.push({ name: "validateotp" })
          });
        }
        else {
          this.$notify({
            type: 'warning',
            title: 'Please fill in all fields'
          });
        }
      }
    }
  }
</script>
<style>
</style>
